// This import loads the firebase namespace along with all its type information.
import Reply from './reply-model'

export async function load_replys(): Promise<Reply[]> {
  throw 'Not implemented'
}

export async function delete_reply(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_reply(): Promise<Reply> {
  throw 'Not implemented'
}
